import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ForkliftTopHead from './forklift-top-head';
import ForkliftContent from './forklift-content';
import ForkliftModals from './forklift-modals';
import { actions as forkliftActions, fetchForkliftsWithFilters } from './store/slice';

const { resetFilters } = forkliftActions;

const ForkliftView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchForkliftsWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Forklift</h4>
              </div>
            </div>
            <ForkliftTopHead />
          </div>
          <ForkliftContent />
          <ForkliftModals />
        </div>
      </div>
    </div>
  );
};

export default ForkliftView;
